import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import { LMap, LTileLayer, LMarker } from 'vue2-leaflet';
import 'leaflet/dist/leaflet.css';
import JsonCSV from 'vue-json-csv'

import VueLoading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

Vue.use(VueLoading);

Vue.component('downloadCsv', JsonCSV)


import {messaging} from './firebase/db.js'

Vue.prototype.$messaging = messaging

Vue.component('l-map', LMap);
Vue.component('l-tile-layer', LTileLayer);
Vue.component('l-marker', LMarker);

import VueQrcodeReader from "vue-qrcode-reader";

Vue.use(VueQrcodeReader);

Vue.config.productionTip = false

import VTooltip from 'v-tooltip'
import './registerServiceWorker'

Vue.use(VTooltip)

import VueVirtualScroller from 'vue-virtual-scroller'

Vue.use(VueVirtualScroller)
import 'vue-virtual-scroller/dist/vue-virtual-scroller.css'


new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
